import React, { useState } from "react";
import api, { formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import { toast } from "sonner";
import { Clock, AlertTriangle } from "lucide-react";

const FIELDS = ["legal_name", "brand_name", "contact_name", "phone", "address", "vat_or_tax", "category", "opening_hours", "zone", "fulfillment_notes"];
const LBL = { legal_name: "Ragione sociale", brand_name: "Nome commerciale", contact_name: "Referente (nome e cognome)", phone: "Telefono", address: "Indirizzo completo attività", vat_or_tax: "P.IVA / Codice fiscale", category: "Categoria commerciale", opening_hours: "Orari di apertura", zone: "Comune", fulfillment_notes: "Modalità di preparazione e ritiro" };

function Msg({ icon: Icon, color, title, text, testid }) {
  return <div data-testid={testid} className="max-w-lg mx-auto text-center py-16"><Icon className={`h-14 w-14 mx-auto ${color}`} /><h2 className="text-2xl font-bold mt-4">{title}</h2><p className="text-zinc-400 mt-2">{text}</p></div>;
}

export default function BusinessOnboarding({ business, onUpdate }) {
  const [f, setF] = useState(() => { const o = {}; FIELDS.forEach((k) => (o[k] = business[k] || "")); return o; });
  const [saving, setSaving] = useState(false);
  const save = async (submit) => {
    setSaving(true);
    try {
      await api.put("/business/me", f);
      if (submit) { await api.post("/business/submit-review"); toast.success("Candidatura inviata per la verifica"); }
      else toast.success("Bozza salvata");
      onUpdate();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    setSaving(false);
  };
  if (business.status === "pending_review")
    return <Msg icon={Clock} color="text-amber-400" title="La tua candidatura è stata ricevuta" text="Il nostro team verificherà i dati e ti comunicherà l'esito appena possibile." testid="onboarding-pending" />;
  if (business.status === "rejected")
    return <Msg icon={AlertTriangle} color="text-red-400" title="Candidatura non approvata" text={business.rejection_reason || "Contatta l'assistenza per maggiori dettagli."} testid="onboarding-rejected" />;
  if (business.status === "suspended")
    return <Msg icon={AlertTriangle} color="text-red-400" title="Attività sospesa" text={business.rejection_reason || "La tua attività è temporaneamente sospesa."} testid="onboarding-suspended" />;
  return (
    <div data-testid="onboarding-form" className="max-w-2xl">
      {business.status === "more_information_required" && <div className="mb-4 rounded-md border border-orange-500/40 bg-orange-500/10 text-orange-300 px-4 py-2 text-sm">Integrazioni richieste dall'amministrazione: {business.rejection_reason}</div>}
      <h2 className="text-xl font-bold mb-1">Completa il profilo della tua attività</h2>
      <p className="text-sm text-zinc-400 mb-5">Compila tutti i dati e invia la candidatura. Finché non sei approvato, l'attività non è visibile nel marketplace e non riceve ordini.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {FIELDS.map((k) => (
          <div key={k} className={k === "address" || k === "fulfillment_notes" ? "sm:col-span-2" : ""}>
            <Label>{LBL[k]}</Label>
            {k === "fulfillment_notes"
              ? <Textarea data-testid={`ob-${k}`} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="bg-[#1C1C1F] border-white/10 mt-1" />
              : <Input data-testid={`ob-${k}`} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="bg-[#1C1C1F] border-white/10 mt-1" />}
          </div>
        ))}
      </div>
      <div className="flex gap-3 mt-5">
        <Button data-testid="ob-save" onClick={() => save(false)} disabled={saving} variant="secondary">Salva bozza</Button>
        <Button data-testid="ob-submit" onClick={() => save(true)} disabled={saving} className="bg-[#00E676] text-black font-semibold">Invia per la verifica</Button>
      </div>
    </div>
  );
}
